import { VCS_CALL_LS_DATA_KEY } from 'consts';
import type { CallPolicyDraft } from 'state/store';

type CallLsData = {
    roomName: string;
    initiatorId?: string;
    policy?: CallPolicyDraft;
};

const read = (): CallLsData | null => {
    const raw = localStorage.getItem(VCS_CALL_LS_DATA_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw) as CallLsData;
    } catch {
        return null;
    }
};

const write = (data: CallLsData): void => {
    localStorage.setItem(VCS_CALL_LS_DATA_KEY, JSON.stringify(data));
};

export const clearCallLsData = (): void => {
    localStorage.removeItem(VCS_CALL_LS_DATA_KEY);
};

export const setCallLsInitiatorId = (roomName: string, initiatorId: string): void => {
    const existing = read();
    const base = existing?.roomName === roomName ? existing : { roomName };
    write({ ...base, initiatorId });
};

export const setCallLsPolicy = (roomName: string, policy: CallPolicyDraft): void => {
    const existing = read();
    const base = existing?.roomName === roomName ? existing : { roomName };
    write({ ...base, policy });
};

/**
 * Возвращает initiatorId если данные относятся к этой комнате.
 * Если roomName не совпадает — данные устарели, чистим и возвращаем null.
 */
export const getCallLsInitiatorId = (roomName: string): string | null => {
    const data = read();
    if (!data) return null;
    if (data.roomName !== roomName) {
        clearCallLsData();
        return null;
    }
    return data.initiatorId ?? null;
};

/**
 * Возвращает policy если данные относятся к этой комнате.
 * Если roomName не совпадает — данные устарели, чистим и возвращаем null.
 */
export const getCallLsPolicy = (roomName: string): CallPolicyDraft | null => {
    const data = read();
    if (!data) return null;
    if (data.roomName !== roomName) {
        clearCallLsData();
        return null;
    }
    return data.policy ?? null;
};
